import { all, takeLatest } from 'redux-saga/effects';

import { postPublicMemberControllerAction } from '@/redux/actions';

import { postPublicMemberControllerSaga } from './post-public-member-controller';

export default function* root(): Generator {
  yield all([takeLatest(postPublicMemberControllerAction.request.type, postPublicMemberControllerSaga)]);
}
